import script from "./ContactView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=ts"

import "./ContactView.vue?vue&type=style&index=0&id=33e2da54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e2da54"]])

export default __exports__